// extracted by mini-css-extract-plugin
export default {"close":"Cookie_close__d4B01","show":"Cookie_show__rIXBq","cook":"Cookie_cook__U-V2I"};